
import { CheckCircle, AlertTriangle, Clock } from 'lucide-react';

export const getStatusColor = (status: string) => {
  switch (status) {
    case 'approved':
      return 'bg-green-100 text-green-800 border-green-200';
    case 'active':
    case 'pending':
      return 'bg-red-100 text-yellow-800 border-yellow-200';
    case 'submitted':
      return 'bg-blue-100 text-blue-800 border-blue-200';
    case 'needs-revision':
      return 'bg-red-100 text-red-800 border-red-200';
    default:
      return 'bg-gray-100 text-gray-800 border-gray-200';
  }
};

export const getStatusIcon = (status: string) => {
  switch (status) {
    case 'completed':
    case 'submitted':
      return CheckCircle;
    case 'needs-revision':
      return AlertTriangle;
    default:
      return Clock;
  }
};

export const mapReviewStatusToDocumentStatus = (reviewStatus: string): 'pending' | 'submitted' | 'approved' | 'needs-revision' => {
  switch (reviewStatus?.toLowerCase()) {
    case 'approved':
      return 'approved';
    case 'needs revision':
    case 'needs-revision':
      return 'needs-revision';
    case 'submitted':
      return 'submitted';
    case 'pending':
    default:
      return 'pending';
  }
};
